"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ViewFaqQuestion = void 0;
// http://dsheiko.com/weblog/writing-backbone-applications-in-typescript
var withMName_1 = require("../../utils/withMName");
var Backbone = __importStar(require("backbone"));
var ViewFaqQuestion = /** @class */ (function (_super) {
    __extends(ViewFaqQuestion, _super);
    function ViewFaqQuestion(options) {
        return _super.call(this, options) || this;
    }
    ViewFaqQuestion.prototype.events = function () {
        return {
            'click .js-question-question': this.toggleAnswer.mname
        };
    };
    ViewFaqQuestion.prototype.render = function () {
        return this;
    };
    ViewFaqQuestion.prototype.toggleAnswer = function () {
        var answer = this.$el.find('.js-question-answer');
        if (answer.is(':visible')) {
            answer.slideUp();
            this.$el.removeClass('expanded');
        }
        else {
            answer.slideDown();
            this.$el.addClass('expanded');
        }
    };
    __decorate([
        withMName_1.withMName
    ], ViewFaqQuestion.prototype, "toggleAnswer", null);
    return ViewFaqQuestion;
}(Backbone.View));
exports.ViewFaqQuestion = ViewFaqQuestion;
